import axios from "axios";

export const getAuthHeader = async () => {
    const sessionId = localStorage.getItem("sessionId");
    if (!sessionId) throw new axios.Cancel('No auth credentials found');
    return sessionId;
}